import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { OnBoardingService } from '../../../on-boarding/services/on-boarding.service';
import { GoogleAnalyticsService } from '../../../services/googleanalytics.service';
import { GoogleAnalyticsEvents } from '../../../models/GoogleAnalyticsEvents';

@Component({
  selector: 'app-state-management-buttons',
  templateUrl: './state-management-buttons.component.html',
  styleUrls: ['./state-management-buttons.component.scss']
})
export class StateManagementButtonsComponent implements OnInit {
  @Input() showWarningLabel = true;
  @Input() finish = false;
  @Input() saveOnDB = true;
  @Input() validBtn = false;
  @Input() hasBackButton = true;
  @Input() currentState: number;
  @Input() availableSteps: number[];
  @Output() forwardStateChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() backwardsStateChange: EventEmitter<number> = new EventEmitter<number>();

  private _analyticsEvents = new GoogleAnalyticsEvents();

  constructor(
    private router: Router,
    public onBoardingService: OnBoardingService,
    private _analyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit(): void {
  }

  hasBack() {
    if (this.availableSteps && this.availableSteps.indexOf(this.currentState) > 0) {
      return this.hasBackButton;
    } else if (this.onBoardingService.onBoardingNavigation.value.findIndex(item => ('/' + item.uri) === this.router.url) > 0) {
      return this.hasBackButton;
    }

    return false;
  }

  goBack() {
    if (this.availableSteps && this.availableSteps.indexOf(this.currentState) > 0) {
      this.backwardsStateChange.emit(this.currentState - 1);
    } else if (this.onBoardingService.onBoardingNavigation.value.findIndex(item => ('/' + item.uri) === this.router.url) > 0) {
      this.onBoardingService.state.next(this.currentState - 1);
      this.onBoardingService.goBack();
    }

    this._analyticsService.eventEmitter(this._analyticsEvents.onboarding.category,
      this._analyticsEvents.onboarding.action.navigation_back.name,
      this._analyticsEvents.onboarding.action.navigation_back.label
    );
  }

}
